import * as reports from '../xhr/reports.js';
import * as notifier from './notifier.js';
import * as loader from './loader.js';

/**
 * @param dispatch
 * @param isLoading
 * @param type
 */
function setLoader(dispatch, isLoading, type = 'full') {
    dispatch(loader.setLoader({
        isLoading,
        type
    }));
}

/**
 * @param type
 * @param filters
 * @returns {function(*=): Promise<boolean | never>}
 */
export function generateReport(type, filters, accountID = null) {
    return (dispatch) => {
        setLoader(dispatch, true);
        return reports
            .generate(type, filters, accountID)
            .then((data) => {
                setLoader(dispatch, false);
                return data;
            })
            .catch((error) => {
                setLoader(dispatch, false);
                dispatch(notifier.displayError(error));
            });
    };
}